module.exports = __webpack_public_path__ + "media/SERF25-0600-Sensitive_Information.a9e91224.mp4";